(function () {

    'use strict';
    angular.module('app')
        .service('stateService', ['$rootScope', function ($rootScope) {
            var service = {
                states: new Array(),

                model: {},

                saveState: function (args, controller) {
                    service.states[controller] = angular.toJson(service.model);
                },

                restoreState: function (args, controller) {
                    if (service.states[controller] != undefined) {
                        service.model = angular.fromJson(service.states[controller]);
                    } else {
                        service.model = {};
                    }
                }
            };

            $rootScope.$on('saveState', service.saveState);
            $rootScope.$on('restoreState', service.restoreState);

            return service;
        }

        ]
            );
})();
